import { ReactElement, ReactNode } from 'react';

import { cn } from '../../utils';

import styles from './styles.module.scss';

export interface ButtonProps {
  children: ReactNode;
  onClick: () => void;
  isDisabled?: boolean;
  type: 'primary' | 'secondary' | 'default';
  textSize?: 'small' | 'normal';
  backgroundType?: 'gradient' | 'image';
  color?: string;
}

export const Button = ({
  children,
  onClick,
  isDisabled = false,
  textSize = 'normal',
  type,
  backgroundType = 'gradient',
  color,
}: ButtonProps): ReactElement => {
  if (backgroundType === 'image') {
    return (
      <button
        data-test="main-action-button"
        type="submit"
        disabled={isDisabled}
        onClick={onClick}
        className={cn([
          styles.button,
          styles[textSize],
          'button-theme-customize',
          `button-theme-customize-${type}`,
          color && `button-theme-customize-${type}-${color}`,
        ])}
      >
        {children}
      </button>
    );
  }

  return (
    <button
      data-test="main-action-button"
      type="submit"
      disabled={isDisabled}
      onClick={onClick}
      className={cn([styles.button, styles[textSize]])}
    >
      {children}
    </button>
  );
};
